import API_URL from '../config/config';

const validCoordinate = (latitude, longitude) =>
  Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude)) &&
  Number(latitude) >= 6 && Number(latitude) <= 38 &&
  Number(longitude) >= 68 && Number(longitude) <= 98;

let pendingServiceArea;

const request = async (path) => {
  const response = await fetch(`${String(API_URL).trim()}${path}`, {
    cache: 'no-store',
    credentials: 'include',
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.success !== true) {
    throw new Error(data?.message || 'Unable to verify serviceability right now. Please try again.');
  }
  return data;
};

// The CRM owns the live centre/radius, exactly as in the customer app. Final
// quote/order requests enforce it again on the server.
export const loadServiceArea = () => {
  if (pendingServiceArea) return pendingServiceArea;
  pendingServiceArea = request('/order/serviceable-area').then((data) => {
    const latitude = Number(data?.serviceArea?.center?.latitude);
    const longitude = Number(data?.serviceArea?.center?.longitude);
    const radiusKm = Number(data?.serviceArea?.radiusKm);
    if (!validCoordinate(latitude, longitude) || !Number.isFinite(radiusKm) || radiusKm < 1 || radiusKm > 200) {
      throw new Error('Service area is temporarily unavailable. Please try again.');
    }
    return { latitude, longitude, radiusKm };
  }).finally(() => {
    pendingServiceArea = undefined;
  });
  return pendingServiceArea;
};

export const checkAddressServiceability = async (location) => {
  const latitude = Number(location?.latitude);
  const longitude = Number(location?.longitude);
  if (!validCoordinate(latitude, longitude)) {
    return { serviceable: false, message: 'Please select a valid Indian address.' };
  }
  const query = new URLSearchParams({ latitude: String(latitude), longitude: String(longitude) });
  return request(`/order/serviceability?${query}`);
};

export const serviceAreaRestriction = ({ latitude, longitude, radiusKm }) => {
  const angularRadius = radiusKm / 6371;
  const latDelta = angularRadius * 180 / Math.PI;
  const lngDelta = Math.asin(Math.sin(angularRadius) / Math.cos(latitude * Math.PI / 180)) * 180 / Math.PI;
  return `rectangle:${latitude - latDelta},${longitude - lngDelta}|${latitude + latDelta},${longitude + lngDelta}`;
};
